import { inject, Injectable } from '@angular/core';

import { AnalyticsEventName, AnalyticsService } from '@lite-workspace/shared/services/analytics';

export type ShareLinkType = 'coordinator' | 'class';

@Injectable({ providedIn: 'root' })
export class ShareAnalyticsService {
  private readonly analytics = inject(AnalyticsService);

  modalOpened(projectId: string): void {
    this.analytics.track(AnalyticsEventName.SHARE_MODAL_OPENED, { project_id: projectId });
  }

  linkCopied(input: { projectId: string | undefined; type: ShareLinkType }): void {
    this.analytics.track(AnalyticsEventName.PROJECT_LINK_SHARED, {
      project_id: input.projectId,
      link_type: input.type,
    });
  }

  /** Вход в отбор за ученика — обе точки («Выбрать за ученика» на карточке и в её меню) ведут сюда. */
  selectionForStudentStarted(input: { projectId: string; personId: string }): void {
    this.analytics.track(AnalyticsEventName.SELECTION_FOR_STUDENT_STARTED, {
      project_id: input.projectId,
      person_id: input.personId,
    });
  }
}
